import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  TemplateRef,
  ViewEncapsulation,
  contentChild,
  inject,
  input,
} from '@angular/core';
import { PinnaklIconComponent } from '@pinnakl/shared/ui/icons';

import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'prime-simple-yes-no-header',
  imports: [PinnaklIconComponent, NgTemplateOutlet],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './simple-yes-no-header.component.html',
})
export class SimpleYesNoHeaderComponent {
  private readonly dialogRef = inject(DynamicDialogRef, { optional: true });

  readonly label = input<string>('');
  readonly showClose = input<boolean>(true);
  readonly customHeader = contentChild<TemplateRef<any> | null>('customHeader');

  @Output() onClose: EventEmitter<void>;

  constructor() {
    this.onClose = new EventEmitter<void>();
  }

  closeIconHandler(): void {
    this.dialogRef?.close();
    this.onClose.emit(undefined);
  }
}
